import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PolicyConfigurationComponent } from './policy-configuration/policy-configuration.component';
import { MainMenusComponent } from './main-menus/main-menus.component';
import { HeaderComponent } from './header/header.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { LoginComponent } from './login/login.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AuthGuardService } from './guards/auth-guard.service';
import { DeclarationComponent } from './declaration/declaration.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatePipe, CurrencyPipe, TitleCasePipe } from '@angular/common'
import {NgxTypeaheadModule} from'ngx-typeahead'
import { FileUploadModule } from 'ng2-file-upload';
import { DndDirective } from './dnd.directive';
//import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { GroupMasterComponent } from './masters/group-master/group-master.component';
import { Globals } from './globals';
import {ExcelServiceService} from './excel-service.service';
import { CommonService } from './common.service';
import { StorageService } from './storage.service';
import { CommonVariablesService } from './common-variables.service';
import { MasterPolicyCompleteComponent } from './master-policy-complete/master-policy-complete.component';
import { CountryMasterComponent } from './masters/country-master/country-master.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';
import { NgxCaptchaModule } from 'ngx-captcha';
import { StatementOfAccountsComponent } from './statement-of-accounts/statement-of-accounts.component';
import { ReportsComponent } from './reports/reports.component';
import { CertificateComponent } from './declaration/certificate/certificate.component';
import { BulkDeclarationComponent } from './declaration/bulk-declaration/bulk-declaration.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { RoeMasterComponent } from './masters/roe-master/roe-master.component';
import { SearchPipe } from './_pipe/search/search.pipe';
import { SimpleStatementOfAccountsComponent } from './simple-statement-of-accounts/simple-statement-of-accounts.component';
import { DetailedStatementOfAccountsComponent } from './detailed-statement-of-accounts/detailed-statement-of-accounts.component';
import { ToastrModule } from 'ngx-toastr';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { GcToIncompletelisterrorlogComponent } from './reports/gc-to-incompletelisterrorlog/gc-to-incompletelisterrorlog.component'
import { IncompleteToCompletelisterrorlogComponent } from './reports/incomplete-to-completelisterrorlog/incomplete-to-completelisterrorlog.component'
import { DeclarationTblComponent } from './declaration/declaration-tbl/declaration-tbl.component';
import { CountrySettlingAgentMappingComponent } from './masters/country-settling-agent-mapping/country-settling-agent-mapping.component';
import { CountrySubvoyageMappingComponent } from './masters/country-subvoyage-mapping/country-subvoyage-mapping.component';
import { DecimalPipe } from '@angular/common';
import { UserReportComponent } from './reports/user-report/user-report.component';
import { VesselExposureReportComponent } from './reports/vessel-exposure-report/vessel-exposure-report.component';
import { DetailedReportComponent } from './reports/detailed-report/detailed-report.component';
import { BulkdeclarationreportComponent } from './reports/bulkdeclarationreport/bulkdeclarationreport.component';
import { ReferralreportComponent } from './reports/referralreport/referralreport.component';
import { SanctioncountryreportComponent } from './reports/sanctioncountryreport/sanctioncountryreport.component';
import { UsersMappingComponent } from './users-mapping/users-mapping.component';
import { InsuringClauseMapperComponent } from './masters/insuring-clause-mapper/insuring-clause-mapper.component';
import { ContactusComponent } from './contactus/contactus.component';
import { AuditTrailComponent } from './audit-trail/audit-trail.component';
import { ExpandableTextareaComponent } from './expandable-textarea/expandable-textarea.component';
import { EncryptPdfComponent } from './encrypt-pdf/encrypt-pdf.component';
import  {  PdfViewerModule  }  from  'ng2-pdf-viewer';
import { MastersComponent } from './masters/masters.component';
import { PolicyEnableComponent } from './policy-enable/policy-enable.component';

@NgModule({
  declarations: [
    AppComponent,
    PolicyConfigurationComponent,
    MainMenusComponent,
    HeaderComponent,
	LoginComponent,
    DeclarationComponent,
    GroupMasterComponent,
    DndDirective,
    MasterPolicyCompleteComponent,
	CountryMasterComponent,
    ChangePasswordComponent,
    StatementOfAccountsComponent,
    ReportsComponent,
    CertificateComponent,
    BulkDeclarationComponent,
	RoeMasterComponent,
	SearchPipe,
    SimpleStatementOfAccountsComponent,
    DetailedStatementOfAccountsComponent,
	DeclarationTblComponent,
    GcToIncompletelisterrorlogComponent,
    IncompleteToCompletelisterrorlogComponent,
    CountrySettlingAgentMappingComponent,
    CountrySubvoyageMappingComponent,
    UserReportComponent,
    VesselExposureReportComponent,
    DetailedReportComponent,
    BulkdeclarationreportComponent,
    ReferralreportComponent,
    SanctioncountryreportComponent,
    UsersMappingComponent,
	InsuringClauseMapperComponent,
	ContactusComponent,
	AuditTrailComponent,
    ExpandableTextareaComponent,
    EncryptPdfComponent,
    MastersComponent,
    PolicyEnableComponent,
    //LoginComponent
    //CustomTemplateListComponent,
    //StaticListComponent
  ],
  imports: [
    BrowserModule,
	SelectDropDownModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    DataTablesModule,
    AppRoutingModule,
    NgxTypeaheadModule,
    NgxSpinnerModule,
    NgxCaptchaModule.forRoot({
        reCaptcha2SiteKey: '6Ldw5e8UAAAAADiL5XuSe0wF2DfvcwiAVrQ48fSF'
      }),
    FileUploadModule,
    TabsModule.forRoot(),
    AccordionModule.forRoot(),
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
	CollapseModule.forRoot(),
	TypeaheadModule.forRoot(),
	//AngularFontAwesomeModule,
	FormsModule,
	ReactiveFormsModule,
	HttpClientModule,
    NgMultiSelectDropDownModule.forRoot(),
    ToastrModule.forRoot({closeButton: true}),
	RouterModule.forRoot([	
        {
            path: 'login',
            component: LoginComponent
        },
		{
            path: '',
            component: LoginComponent
        },
	
        {
            path: 'masters/groupmaster',
            component: GroupMasterComponent,
			canActivate: [AuthGuardService]
        },
		{
            path: 'policy-configuration/:id/:status',
         //   name: 'PolicyConfig',
            component: PolicyConfigurationComponent,
			canActivate: [AuthGuardService]
        },
		{
            path: 'master-policy-complete',
            component: MasterPolicyCompleteComponent,
			canActivate: [AuthGuardService]
        },
        {
            path: 'audit-trail',
            component:AuditTrailComponent,
            canActivate:[ AuthGuardService]
        },
		{
            path: 'change-password',
            component: ChangePasswordComponent,
			canActivate: [AuthGuardService]
        },
        {
            path: 'masters/countrymaster',
            component: CountryMasterComponent,
			canActivate: [AuthGuardService]
        },
        {
            path: 'masters/countrysettlingagentmapping',
            component: CountrySettlingAgentMappingComponent,
			canActivate: [AuthGuardService]
        },
        {
            path: 'masters/countrysubvoyagemapping',
            component: CountrySubvoyageMappingComponent,
			canActivate: [AuthGuardService]
        },
        {
            path: 'masters/insuringClauseMapper',
            component: InsuringClauseMapperComponent,
			canActivate: [AuthGuardService]
        },
        {
            path: 'declaration/:id',
            component: DeclarationComponent,
			canActivate: [AuthGuardService]
        },
        {
            path: "masters/roemaster",
            component: RoeMasterComponent,
            canActivate: [AuthGuardService]
        },
        {
            path: "statement-of-accounts",
            component: StatementOfAccountsComponent,
            canActivate: [AuthGuardService]
        },
        {
            path: "certificate",
            component: CertificateComponent,
            canActivate: [AuthGuardService]
        },
        {
            path: "bulk-declaration",
            component: BulkDeclarationComponent,
            canActivate: [AuthGuardService]
        },
        {
            path: "soa/simple-statement-of-accounts",
            component: SimpleStatementOfAccountsComponent,
            canActivate: [AuthGuardService]
        },{
            path:"soa/detailed-statement-of-accounts",
            component:DetailedStatementOfAccountsComponent,
            canActivate:[AuthGuardService]
        },
        {
            path:"reports/bulkdeclarationReport",
            component:BulkdeclarationreportComponent,
            canActivate:[AuthGuardService]
        },
        {
            path:"reports/referralReport",
            component:ReferralreportComponent,
            canActivate:[AuthGuardService]
        },
        {
            path:"reports/sanctionCountryReport",
            component:SanctioncountryreportComponent,
            canActivate:[AuthGuardService]
        },
        {
            path:"reports/gctoincompletelisterrorlog",
            component:GcToIncompletelisterrorlogComponent,
            canActivate:[AuthGuardService]
        },
        {
            path:"reports/incompletetocompletelisterrorlog",
            component:IncompleteToCompletelisterrorlogComponent,
            canActivate:[AuthGuardService]
        },
        {
            path:"reports/userReport",
            component:UserReportComponent,
            canActivate:[AuthGuardService]
        },
        {
            path:"reports/vesselExposureReport",
            component:VesselExposureReportComponent,
            canActivate:[AuthGuardService]
        },
        {
            path:"reports/detailedReport",
            component:DetailedReportComponent,
            canActivate:[AuthGuardService]
        },
        {
            path: "declaration-tbl",
            component: DeclarationTblComponent,
            canActivate: [AuthGuardService]
        },
        {
            path: "usersMapping",
            component: UsersMappingComponent,
            canActivate: [AuthGuardService]
        },
        {
            path: "policy_enable",
            component: PolicyEnableComponent,
            canActivate: [AuthGuardService]
        },
        {
            path: "contactus",
            component: ContactusComponent,
            canActivate: [AuthGuardService]
        },
        {
            path: "encrypt-pdf",
            component: EncryptPdfComponent
        }
		 
    ]),
    BsDropdownModule.forRoot(),
    FontAwesomeModule,
    FormsModule,
    PdfViewerModule
  ],
  providers: [Globals,ExcelServiceService,CommonService,StorageService,CommonVariablesService,{provide : LocationStrategy , useClass: HashLocationStrategy},DatePipe,CurrencyPipe,DecimalPipe,DeclarationTblComponent,TitleCasePipe,SearchPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
